module.exports = __webpack_public_path__ + "static/media/timer.7a3972f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sources/images/works__logo/timer.svg
// module id = 721
// module chunks = 0